import React from 'react'
import { Col, Row } from 'antd'
import { FormikProps } from 'formik'

import { Id, RequestStandardBilling } from 'src/types'

import { Input, SelectResource } from 'src/components/Formik'

type Props = {
  enable_billing_observation: boolean
  formikProps: FormikProps<RequestStandardBilling>
  organization_id: Id
}

function FormFields({
  enable_billing_observation = false,
  formikProps,
  organization_id
}: Props): JSX.Element {
  /* billing_reference_type
  type OptionBillingReferenceTypeList = {label: string;value: BillingReferenceType;}
  const billingReferenceTypeList = useMemo<OptionBillingReferenceTypeList[]>(
  () => [{ label: 'Contract', value: 'CONTRACT' },{ label: 'Cost center', value: 'COST_CENTER' }],[])
  */

  const billingObservationRequired =
    enable_billing_observation && formikProps.values?.active

  return (
    <>
      <Row gutter={24}>
        {/* billing_reference_type
        <Col span={8}>
          <Select
            autoFocus
            formikProps={formikProps}
            label="web.assignment.billing.form.reference.title"
            name="billing_reference_type"
            options={billingReferenceTypeList}
            placeholder="web.assignment.billing.form.reference.placeholder"
          />
        </Col> */}
        <Col span={12}>
          <SelectResource
            autoFocus
            formikProps={formikProps}
            keyLabel="name"
            keyValue="target_id"
            label="web.assignment.billing.form.target.title"
            name="target_id"
            organization_id={organization_id}
            placeholder="web.assignment.billing.form.target.placeholder"
            resource="targets"
          />
        </Col>
        <Col span={12}>
          <SelectResource
            formikProps={formikProps}
            keyLabel="name"
            keyValue="billing_type_id"
            label="web.assignment.billing.form.billing-type.title"
            name="billing_type_id"
            organization_id={organization_id}
            placeholder="web.assignment.billing.form.billing-type.placeholder"
            resource="billing_types"
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={24}>
          <Input
            data-test-id="billing-observation"
            formikProps={formikProps}
            label="web.assignment.billing.form.observation.title"
            name="observation"
            placeholder="web.assignment.billing.form.observation.placeholder"
            required={billingObservationRequired}
          />
        </Col>
      </Row>
    </>
  )
}

export default FormFields
